var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"span"},[_vm._v(_vm._s(_vm.$prefix)),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.tweeningValue))]},{"value":_vm.tweeningValue}),_vm._v(_vm._s(_vm.$suffix))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }